import Footer from "../../components/Footer";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import Details from "./Details";
import villaArtha from "./villaArtha.json";
import villaAnanda from "./villaAnanda.json";
import villaAlaya from "./villaAlaya.json";

const Villas = () => {
  const { slug } = useParams();
  return (
    <Box>
      {slug === "villa-etisha" ? (
        <Details json={villaArtha} />
      ) : slug === "villa-ananda" ? (
        <Details json={villaAnanda} />
      ) : (
        <Details json={villaAlaya} />
      )}
      <Footer />
    </Box>
  );
};

export default Villas;
